import React from 'react';
import { isWeb } from './platform';
import { Text as OText, I18nManager } from 'react-native';
import { css } from 'constants';
// export { Text };
const styles = css({
    text: { textAlign: 'left' },
    auto: { textAlign: isWeb ? 'left' : 'auto' }
});
/*
export const Text = ({ style, auto_dir, ...props }) => (
    <OText dir={auto_dir ? 'auto' : I18nManager.isRTL ? 'rtl' : 'ltr'} style={[!isWeb && styles.text, !isWeb && auto_dir && styles.auto, style]} {...props} />
);
*/
export const Text = ({ style, ...props }) => <OText style={[styles.text, style]} {...props} />;





// WEBPACK FOOTER //
// ./src/components/core/text.js